export type MonkeHistoryEvent = {
	kind: string; amountSats: number | null; usdAtSale: number | null
	from: string; to: string; date: string; txid?: string; venue?: string
}
export type MonkeHistory = {
	events: MonkeHistoryEvent[]; source: string; fetchedAt: string; coverage: string
}

// Export is RFC 4180 CSV, including quoted commas and doubled quotes.
export function parseMonkeHistory(csv: string): MonkeHistoryEvent[] {
	const rows: string[][] = []
	let row: string[] = [], cell = '', quoted = false
	for (let i = 0; i < csv.length; i++) {
		const c = csv[i]
		if (c === '"') {
			if (quoted && csv[i + 1] === '"') { cell += '"'; i++ } else quoted = !quoted
		} else if (c === ',' && !quoted) { row.push(cell); cell = '' }
		else if (c === '\n' && !quoted) { row.push(cell.replace(/\r$/, '')); rows.push(row); row = []; cell = '' }
		else cell += c
	}
	if (quoted) throw new Error('Incomplete history CSV')
	if (cell || row.length) { row.push(cell.replace(/\r$/, '')); rows.push(row) }
	const headers = rows.shift()
	if (!headers || ['kind', 'amount_sats', 'usd_at_sale', 'from', 'to', 'date'].some((h) => !headers.includes(h))) throw new Error('Invalid history format')
	const number = (s: string) => s.trim() && Number.isFinite(Number(s)) && Number(s) >= 0 ? Number(s) : null
	return rows.filter((r) => r.length === headers.length).map((r) => {
		const data = Object.fromEntries(headers.map((h, i) => [h, r[i]]))
		return { kind: data.kind, amountSats: number(data.amount_sats), usdAtSale: number(data.usd_at_sale), from: data.from, to: data.to, date: data.date }
	}).filter((e) => Number.isFinite(Date.parse(e.date)) && /^[a-z _-]{1,40}$/i.test(e.kind))
		.sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
}

export function historyCsv(events: MonkeHistoryEvent[]) {
	const escape = (value: unknown) => `"${String(value ?? '').replace(/^[=+@-]/, "'$&").replace(/"/g, '""')}"`
	return [['event', 'amount_sats', 'usd_at_sale', 'from', 'to', 'date', 'txid', 'venue'], ...events.map((e) => [e.kind, e.amountSats, e.usdAtSale, e.from, e.to, e.date, e.txid, e.venue])].map((row) => row.map(escape).join(',')).join('\r\n')
}
